const API = {
    /*首页 */
    'home/querysumdata': '/zl.fp.appdomainbind.getfpsumdata.v5/1.0.0/action', //获取首页统计信息
    'home/querysumlog': '/zl.fp.alarm.querysumlog.v5/1.0.0/action', //添加域名信息
    'home/postobjectpolicyforFP': '/zl.fp.fms.common.postObjectPolicy.v5/1.0.0/action',//全局上传文件

    'home/querylogdashboard': '/zl.fp.applogdashboard.querydashboard.v5/1.0.0/action', //首页图表数据
    'home/queryAppLogBySys': '/zl.fp.applogdashboard.querydashboardpersys.v5/1.0.0/action', //首页图表数据


    /*域名*/
    'domainname/addDomainname': '/zl.fp.domainname.add.v5/1.0.0/action', //添加域名信息
    'domainname/deleteDomainname': '/zl.fp.domainname.delete.v5/1.0.0/action', //删除域名信息
    'domainname/editDomainname': '/zl.fp.domainname.edit.v5/1.0.0/action', //编辑域名信息
    'domainname/selectTableList': '/zl.fp.domainname.select.v5/1.0.0/action', //获取域名信息列表
    'domainname/detailDomainname': '/zl.fp.domainname.detail.v5/1.0.0/action', //获取域名信息详情

    /*配置中心*/
    'sys/querysys': '/zl.fp.configcenter.querysys.v5/1.0.0/action', //获取配置中心系统列表
    'sys/selectsys': '/zl.fp.configcenter.selectsys.v5/1.0.0/action', //获取配置中心系统列表
    'sys/refreshAppVersion': '/zl.fp.fpv5.app.refreshAppVersion.v5/1.0.0/action', //获取配置中心系统列表

    'sys/addsys': '/zl.fp.configcenter.addsys.v5/1.0.0/action', //新增配置中心系统列表
    'sys/deletesys': '/zl.fp.configcenter.deletesys.v5/1.0.0/action', //删除配置中心系统列表
    'sys/editsys': '/zl.fp.configcenter.editsys.v5/1.0.0/action', //编辑配置中心系统列表
    'sys/detailSys': '/zl.fp.configcenter.detailsys.v5/1.0.0/action', //获取当个配置信息'
    'sys/bindPlatforms': '/zl.fp.configcenter.bindPlatforms.v5/1.0.0/action', //获取当个配置信息'
    'sys/querybinds': '/zl.fp.configcenter.querybinds.v5/1.0.0/action', //获取当个配置信息'

    'sys/addDomainUrl': '/zl.fp.domainurl.add.v5/1.0.0/action',//添加系统域名
    'sys/selectDomainUrl': '/zl.fp.domainurl.select.v5/1.0.0/action',//查询系统域名
    'sys/detailDomainUrl': '/zl.fp.domainurl.detail.v5/1.0.0/action',//详情系统域名
    'sys/deleteDomainUrl': '/zl.fp.domainurl.delete.v5/1.0.0/action',//删除系统域名
    'sys/updateDomainUrl': '/zl.fp.domainurl.update.v5/1.0.0/action',//更新系统域名

    //-- app管理
    'app/queryapp': '/zl.fp.configcenter.queryapp.v5/1.0.0/action', //获取配置中心app列表
    'app/addapp': '/zl.fp.configcenter.addapp.v5/1.0.0/action', //新增配置中心app列表
    'app/deleteapp': '/zl.fp.configcenter.deleteapp.v5/1.0.0/action', //删除配置中app列表
    'app/editapp': '/zl.fp.configcenter.editapp.v5/1.0.0/action', //编辑配置中心app列表
    'app/refreshAppNode': '/zl.fp.system.checks.v5/1.0.0/action',//app节点查询
    'app/refreshOneAppNode': '/zl.fp.system.nodeCheck.v5/1.0.0/action',//app节点查询
    'app/selectAppNode': '/zl.fp.appnode.query.v5/1.0.0/action',//app节点查询

    //-- 文件管理
    'configcenter/queryfile': '/zl.fp.configcenter.queryfile.v5/1.0.0/action', //获取配置中心file列表
    'configcenter/addfile': '/zl.fp.configcenter.addfile.v5/1.0.0/action', //新增配置中心file列表
    'configcenter/deletefile': '/zl.fp.configcenter.deletefile.v5/1.0.0/action', //删除配置中心file列表
    'configcenter/editfile': '/zl.fp.configcenter.editfile.v5/1.0.0/action', //编辑配置中心file列表
    'configcenter/editGlobal': '/zl.fp.fpv5.globalConfig.update.v5/1.0.0/action', //编辑全局配置
    'configcenter/queryGlobal': '/zl.fp.fpv5.globalConfig.query.v5/1.0.0/action', //查询全局配置


    //-- 处理器配置
    'configcenter/cpu_add': '/zl.fp.zkms.processorConfig.add.v5/1.0.0/action', //新增
    'configcenter/cpu_del': '/zl.fp.zkms.processorConfig.del.v5/1.0.0/action', //删除
    'configcenter/cpu_edit': '/zl.fp.zkms.processorConfig.edit.v5/1.0.0/action', //编辑
    'configcenter/cpu_reflush': '/zl.fp.zkms.processorConfig.refresh.v5/1.0.0/action', //刷新
    'configcenter/cpu_detail': '/zl.fp.zkms.processorConfig.query.v5/1.0.0/action', //详情
    'configcenter/cpu_page': '/zl.fp.zkms.processorConfig.queryListPage.v5/1.0.0/action', //列表


    //-- 文件中间件管理
    'configcenter/querymidfile': '/zl.fp.configcenter.querymidfile.v5/1.0.0/action', //获取配置中心file列表

    //配置管理-记录
    'configcenter/queryconfiglogpage': 'zl.fp.configlogcenter.queryconfiglogpage.v5/1.0.0/action', //配置中心-记录列表
    'configcenter/detailconfiglogpage': 'zl.fp.configlogcenter.detailconfiglog.v5/1.0.0/action', //配置中心-记录详情


    /* 登录 */
    "home/loginOLD": "/zl.fp.user.login.v5/1.0.0/action", //磐石系统用户登录
    "home/login": "/zl.fp.unite.user.doLogin.v5/1.0.0/action", //磐石系统用户登录
    "home/loginout": "/zl.fp.unite.user.doLogout.v5/1.0.0/action", // 磐石系统用户注销登录
    /*风控规则*/
    "rc/select": "/zl.fp.rule.query.v5/1.0.0/action", //获取风控规则列表
    "rc/add": "/zl.fp.rule.create.v5/1.0.0/action", //添加风控规则
    "rc/del": "/zl.fp.rule.delete.v5/1.0.0/action", //删除风控规则
    "rc/edit": "/zl.fp.rule.update.v5/1.0.0/action", //编辑风控规则
    "rc/detail": "/zl.fp.rule.detail.query.v5/1.0.0/action", //编辑风控规则

    /*黑名单*/
    "rc/namelist/select": "/zl.fp.nl.query.v5/1.0.0/action", //获取名单列表
    "rc/namelist/add": "/zl.fp.nl.add.v5/1.0.0/action", //添加名单
    "rc/namelist/del": "/zl.fp.nl.delete.v5/1.0.0/action", //删除名单
    "rc/namelist/lishi": "/zl.fp.nl.history.query.v5/1.0.0/action", //名单历史记录
    "rc/namelist/zhixing": "/zl.fp.nl.black.record.query.v5/1.0.0/action", //黑名单执行记录查询

    /* 流量控制 */
    "rc/io/sysadd": "/zl.fp.tc.config.main.system.add.v5/1.0.0/action", //添加系统
    "rc/io/syslist": "/zl.fp.tc.config.main.query.v5/1.0.0/action", //系统列表查询
    "rc/io/delserver": "/zl.fp.tc.config.main.server.delete.v5/1.0.0/action", //删除服务器
    "rc/io/editflag": "/zl.fp.tc.config.enable.v5/1.0.0/action", //禁用/启用服务器配置
    "rc/io/copyserver": "/zl.fp.tc.config.main.server.copy.v5/1.0.0/action", //复制服务器
    "rc/io/refreshserver": "/zl.fp.tc.config.refresh.v5/1.0.0/action", //刷新服务器
    "rc/io/addserver": "/zl.fp.tc.config.main.server.add.v5/1.0.0/action", //添加服务器
    "rc/io/configlist": "/zl.fp.tc.config.query.v5/1.0.0/action", //配置列表查询
    "rc/io/addconfig": "/zl.fp.tc.config.add.v5/1.0.0/action", //添加配置
    "rc/io/editconfig": "/zl.fp.tc.config.update.v5/1.0.0/action", //修改配置
    "rc/io/delconfig": "/zl.fp.tc.config.delete.v5/1.0.0/action", //删除配置

    /*服务*/
    "servicekey/select": "/zl.fp.service.query.v5/1.0.0/action", //获取服务列表
    "servicekey/add": "/zl.fp.service.add.v5/1.0.0/action", //添加服务
    "servicekey/del": "/zl.fp.service.delete.v5/1.0.0/action", //删除服务
    "servicekey/edit": "/zl.fp.service.update.v5/1.0.0/action", //修改服务
    "servicekey/detail": "/zl.fp.service.detail.query.v5/1.0.0/action", //服务详情
    "servicekey/jibie": "/zl.fp.service.level.query.v5/1.0.0/action", //服务级别查询
    "servicekey/batupdate": "/zl.fp.service.level.batch.update.v5/1.0.0/action", //服务级别批量修改
    "servicekey/batsetting": "/zl.fp.service.level.batch.set.v5/1.0.0/action", //服务级别批量设置
    "servicekey/rizhi": "/zl.fp.log.level.query.v5/1.0.0/action", //日志级别查询
    "servicekey/rizhiupdate": "/zl.fp.log.level.update.v5/1.0.0/action", //日志级别修改
    "servicekey/getAuthedAppList": "/zl.fp.appauthcode.query.v5/1.0.0/action", //查询app授权
    "servicekey/getAppList": "/zl.fp.appauthcode.queryapplist.v5/1.0.0/action",//查询app列表
    "servicekey/addOrUpdateApp": "/zl.fp.appauthcode.saveorupdate.v5/1.0.0/action",
    "servicekey/deleteAuthedApp": "/zl.fp.appauthcode.del.v5/1.0.0/action",
    "servicekey/exportService": "/zl.fp.common.export.v5/1.0.0/action",//导出服务列表
    "servicekey/checkExportStatue": "/zl.fp.data.queryexportrecordstatus.v5/1.0.0/action",//导出服务列表状态
    "servicekey/importConfig": "zl.fp.file.postobjectpolicyforOpen.v5/1.0.0/action",//获取导入配置
    "servicekey/saveImportService": "/zl.fp.common.import.v5/1.0.0/action",//导入记录
    "servicekey/checkImportStatue": "/zl.fp.import.query.v5/1.0.0/action",//导入记录查询
    "servicekey/queryriskconfig": "/zl.fp.appriskconfig.query.v5/1.0.0/action",//查询配置参数列表
    "servicekey/deleteriskconfig": "/zl.fp.appriskconfig.delete.v5/1.0.0/action",//删除配置参数列表
    "servicekey/detailriskconfig": "/zl.fp.appriskconfig.detail.v5/1.0.0/action",//缓存获取配置参数列表
    "servicekey/updateriskconfig": "/zl.fp.appriskconfig.update.v5/1.0.0/action",//更新或新增配置参数列表
    "servicekey/queryriskconfiglist": "/zl.fp.appriskconfig.querylist.v5/1.0.0/action",//详情配置参数列表
    "servicekey/queryunauthedservice": "/zl.fp.appriskconfig.queryAuthedServiceList.v5/1.0.0/action",//详情配置参数列表

    "servicekey/queryAppriskconfig": "/zl.fp.appriskconfig.queryappauthlist.v5/1.0.0/action",//查询App配置参数列表
    "servicekey/deleteAppriskconfig": "/zl.fp.appriskconfig.deleteappauth.v5/1.0.0/action",//删除App配置参数列表
    "servicekey/detailAppriskconfig": "/zl.fp.appriskconfig.detailappauth.v5/1.0.0/action",//缓存获取App配置参数列表
    "servicekey/updateAppriskconfig": "/zl.fp.appriskconfig.updateappauth.v5/1.0.0/action",//更新或新增App配置参数列表

    //0418
    "servicekey/compare": "/zl.fp.service.compare.v5/1.0.0/action", //对比测试环境服务
    "servicekey/cover": "/zl.fp.service.cover.v5/1.0.0/action", //覆盖服务
    "servicekey/coverP": "/zl.fp.service.cover.v5/1.0.0/action", //覆盖服务
    "servicekey/coverAll": "/zl.fp.service.coverall.v5/1.0.0/action", //覆盖所有




    /*定时任务*/
    "timetask/selectTask": "/zl.fp.jobms.jobconfig.manage.v5/1.0.0/action", //获取定时任务列表
    "timetask/deleteTask": "/zl.fp.jobms.jobconfig.delJob.v5/1.0.0/action", //删除定时任务
    "timetask/unlockTask": "/zl.fp.jobms.jobconfig.restartjob.v5/1.0.0/action", //解锁
    "timetask/detailTask": "/zl.fp.jobms.jobconfig.getJobConfig.v5/1.0.0/action", //详情
    "timetask/updateTask": "/zl.fp.jobms.jobconfig.toupdatejobconfig.v5/1.0.0/action", //保存定时任务
    "timetask/addTask": "/zl.fp.jobms.jobconfig.toadd.v5/1.0.0/action", //修改定时任务
    "timetask/startTask": "/zl.fp.jobms.jobconfig.startjob.v5/1.0.0/action", //启动定时任务
    "timetask/selectHistory": "/zl.fp.jobms.jobconfig.queryrecordbyid.v5/1.0.0/action", //查询执行历史记录

    //0426
    "timetask/querydifpage": "/zl.fp.coverjobinfo.querydifpage.v5/1.0.0/action", //对比jobInfo差异
    "timetask/coverone": "/zl.fp.coverjobinfo.coverone.v5/1.0.0/action", //覆盖单条
    "timetask/coverall": "/zl.fp.coverjobinfo.coverall.v5/1.0.0/action", //覆盖所有



    // 组织管理
    "orgcenter/selectOrg": "/zl.fp.system.organization.queryAdminOrganizationPageList.v5/1.0.0/action", //获取组织列表
    "orgcenter/detailOrg": "/zl.fp.system.organization.getAdminOrganizationDetail.v5/1.0.0/action", //获取组织详情
    "orgcenter/updateAddTask": "/zl.fp.system.organization.insterOrUpdateAdminOrganization.v5/1.0.0/action", //编辑或新增组织
    "orgcenter/activeOrg": "/zl.fp.system.organization.updateAdminOrganizationIsvalidity.v5/1.0.0/action", //改变组织状态
    'orgcenter/queryUporg': "/zl.fp.system.organization.queryUpAdminOrganizationPageList.v5/1.0.0/action",//查询上级组织
    'orgcenter/queryUser': "/zl.fp.system.user.queryAdminOrganizationLeaderPageList.v5/1.0.0/action",

    //用户管理

    "usercenter/selectUser": "/zl.fp.system.user.queryAdminUserPageList.v5/1.0.0/action", //获取用户列表
    "usercenter/detailUser": "/zl.fp.system.user.getAdminUserDetail.v5/1.0.0/action", //获取用户详情
    "usercenter/updateAddUser": "/zl.fp.system.user.insterOrUpdateAdminUser.v5/1.0.0/action", //新增或修改用户
    "usercenter/changeUser": "/zl.fp.system.user.updateAdminUserUserType.v5/1.0.0/action", //新增或修改用户
    "usercenter/selectOrgList": "/zl.fp.system.organization.selectAdminOrganizationPageList.v5/1.0.0/action", //用户选择组织列表
    "usercenter/selectRoleList": "/zl.fp.userrole.selectpage.v5/1.0.0/action",  //用户选择角色列表
    "usercenter/selectSystemList": "/zl.fp.configcenter.querysys.v5/1.0.0/action",  //用户选择系统列表

    //菜单管理
    "usercenter/addEditMenu": "/zl.fp.setting.menu.v5/1.0.0/action",//有效无效接口
    "usercenter/deleteMenu": "/zl.fp.setting.delmenu.v5/1.0.0/action",//删除菜单


    // 角色管理
    "rolecenter/selectRole": "/zl.fp.userrole.page.v5/1.0.0/action",//角色列表查询
    "rolecenter/addRole": "/zl.fp.userrole.add.v5/1.0.0/action",//添加角色
    "rolecenter/selectAuthUser": "/zl.fp.system.userrole.queryauthuser.v5/1.0.0/action",//查询已授权或者未授权的用户
    "rolecenter/updateMenu": "/zl.fp.menu.update.v5/1.0.0/action",//菜单敏感数据设置
    "rolecenter/selectRoleUser": "/zl.fp.system.user.queryRoleUserPageList.v5/1.0.0/action",//用户授权查询用户接口
    "rolecenter/deleteAuthUser": "/zl.fp.system.userrole.deleteuser.v5/1.0.0/action",//授权页删除用户接口
    "rolecenter/getAllMenu": "/zl.fp.menu.list.v5/1.0.0/action",//获取所有的菜单
    "rolecenter/updateRole": "/zl.fp.userrole.update.v5/1.0.0/action",//编辑角色
    "rolecenter/getRole": "/zl.fp.userrole.info.v5/1.0.0/action",//获取角色信息
    "rolecenter/authUser": "/zl.fp.userrole.accessuser.v5/1.0.0/action",//授权
    "rolecenter/activeRole": "/zl.fp.userrole.effective.v5/1.0.0/action",//有效无效接口

    // 收银机日志管理
    "devicelog/list": "/zl.fp.shop.querydevicelog.v5/1.0.0/action",//设备日志列表查询
    "devicelog/getShopList": "/zl.fp.devicelog.queryshopnames.v5/1.0.0/action",//获取商户列表
    "devicelog/getDevicenumList": "/zl.fp.wsms.querydevicepage/1.0.0/action",// 获取V5设备列表
    "devicelog/pushCommand": "/zl.fp.devicelog.push.v5/1.0.0/action",//推送命令上传日志

    //收银机日志管理v3
    "devicelog/listv3": "/zl.fp.shop.querydevicelog/1.0.0/action",//设备日志列表查询
    "devicelog/getShopListv3": "/zl.fp.devicelog.queryshopnames/1.0.0/action",//获取商户列表
    "devicelog/getDevicenumListv3": "/zl.fp.wsms.querydevicev3page/1.0.0/action",//获取V3设备列表
    "devicelog/pushCommandv3": "/zl.fp.devicelog.push/1.0.0/action",//推送命令上传日志

    // 告警日志管理
    "alarmmanager/list": "/zl.fp.alarm.queryPageList.v5/1.0.0/action",// 告警日志列表查询
    "alarmmanager/details": "/zl.fp.alarm.details.v5/1.0.0/action",//   告警记录详情
    "alarmmanager/edit": "/zl.fp.alarm.edit.v5/1.0.0/action",// 修改告警记录信息
    "alarmmanager/blocklist": "/zl.fp.alarm.blockpagelist.v5/1.0.0/action",//  屏蔽服务列表
    "alarmmanager/deleteblock": "/zl.fp.alarm.deleteblock.v5/1.0.0/action",//  删除屏蔽服务

    // 告警日志分析
    "alarmmanager/queryAnalysisByError": "/zl.fp.alarm.analysis.queryAnalysisByError.v5/1.0.0/action",//  按异常码- 饼状图数据
    "alarmmanager/queryFailAndTimeout": "/zl.fp.alarm.analysis.queryFailAndTimeout.v5/1.0.0/action",//  按超时或失败率 - 折线图数据
    "alarmmanager/queryTotalAnalysisdataList": "/zl.fp.alarm.analysis.queryTotalAnalysisdataList.v5/1.0.0/action",//  总概览 折线图数据
    "alarmmanager/queryAnalysisdetailList": "/zl.fp.alarm.analysis.queryAnalysisByErrorCode.v5/1.0.0/action",//  总概览 折线图数据
    "alarmmanager/serviceurldetails": "/zl.fp.analysis.analysis.serviceurldetails.v5/1.0.0/action",// 某appcode下某服务的

    // 告警人员管理
    "alarmmanager/userlist": "/zl.fp.alarmuser.queryPageList.v5/1.0.0/action",// 告警人员列表查询
    "alarmmanager/userdetails": "/zl.fp.alarmuser.details.v5/1.0.0/action",//   告警人员详情
    "alarmmanager/useredit": "/zl.fp.alarmuser.edit.v5/1.0.0/action",// 修改人员信息
    "alarmmanager/useradd": "/zl.fp.alarmuser.add.v5/1.0.0/action",// 新增人员信息
    "alarmmanager/userdel": "/zl.fp.alarmuser.del.v5/1.0.0/action",// 新增人员信息

    // 告警分组管理
    "alarmmanager/grouplist": "/zl.fp.alarmuser.group.searchGroupPage.v5/1.0.0/action",// 告警分组列表查询
    "alarmmanager/groupdetails": "/zl.fp.alarmuser.group.groupdetails.v5/1.0.0/action",//   告警分组详情
    "alarmmanager/groupedit": "/zl.fp.alarmuser.group.groupedit.v5/1.0.0/action",// 修改分组信息
    "alarmmanager/groupadd": "/zl.fp.alarmuser.group.groupadd.v5/1.0.0/action",// 新增分组信息
    "alarmmanager/groupdel": "/zl.fp.alarmuser.group.groupdel.v5/1.0.0/action",// 删除分组信息
    "alarmmanager/searchGroupPage": "/zl.fp.alarmuser.group.searchGroupPage.v5/1.0.0/action",//分页查询分组

    // 告警 钉钉群管理
    "alarmconfig/dingdinglist": "/zl.fp.fpv5.dingDingConfig.queryPage.v5/1.0.0/action",// 告警钉钉群列表查询
    "alarmconfig/dingdingdetails": "/zl.fp.fpv5.dingDingConfig.details.v5/1.0.0/action",//   告警钉钉群详情
    "alarmconfig/dingdingedit": "/zl.fp.fpv5.dingDingConfig.edit.v5/1.0.0/action",// 修改钉钉群信息
    "alarmconfig/dingdingadd": "/zl.fp.fpv5.dingDingConfig.add.v5/1.0.0/action",// 新增钉钉群信息
    "alarmconfig/dingdingdel": "/zl.fp.fpv5.dingDingConfig.del.v5/1.0.0/action",// 删除钉钉群信息
    "alarmconfig/searchDingdingPage": "/zl.fp.fpv5.dingDingConfig.queryPage.v5/1.0.0/action",//分页查询钉钉群
    "alarmconfig/relatedkey": "/zl.fp.fpv5.dingDingConfig.relatedKey.v5/1.0.0/action",// 订阅接口
    "alarmconfig/delkey": "/zl.fp.fpv5.dingDingConfig.delKey.v5/1.0.0/action",// 删除订阅
    "alarmconfig/querykeyspage": "/zl.fp.fpv5.dingDingConfig.queryKeysPage.v5/1.0.0/action",// 分页查询订阅接口

    // 告警 邮箱与短信配置管理
    "alarmconfig/emaillist": "/zl.fp.alarmconfig.emailandsms.searchPage.v5/1.0.0/action",// 告警邮箱列表查询
    "alarmconfig/emaildetails": "/zl.fp.alarmconfig.emailandsms.details.v5/1.0.0/action",//   告警邮箱详情
    "alarmconfig/emailedit": "/zl.fp.alarmconfig.emailandsms.edit.v5/1.0.0/action",// 修改邮箱信息
    "alarmconfig/emailadd": "/zl.fp.alarmconfig.emailandsms.add.v5/1.0.0/action",// 新增邮箱信息
    "alarmconfig/emaildel": "/zl.fp.alarmconfig.emailandsms.del.v5/1.0.0/action",// 删除邮箱信息
    "alarmconfig/searchEmailPage": "/zl.fp.alarmconfig.emailandsms.searchPage.v5/1.0.0/action",//分页查询钉钉群

    // 告警 服务配置管理
    "alarmconfig/alertconfiglist": "/zl.fp.alarmconfig.alertconfig.searchPage.v5/1.0.0/action",// 告警配置列表查询
    "alarmconfig/alertconfigdetails": "/zl.fp.alarmconfig.alertconfig.details.v5/1.0.0/action",//   告警配置详情
    "alarmconfig/alertconfigedit": "/zl.fp.alarmconfig.alertconfig.edit.v5/1.0.0/action",// 修改配置信息
    "alarmconfig/alertconfigadd": "/zl.fp.alarmconfig.alertconfig.add.v5/1.0.0/action",// 新增配置信息
    "alarmconfig/alertconfigdel": "/zl.fp.alarmconfig.alertconfig.del.v5/1.0.0/action",// 删除配置信息
    "alarmconfig/searchAlertconfigPage": "/zl.fp.alarmconfig.alertconfig.searchPage.v5/1.0.0/action",//分页查询配置

    // 告警 历史记录
    "alarmconfig/alerthistorylist": "/zl.fp.alarmconfig.alerthistory.searchPage.v5/1.0.0/action",// 告警消息历史记录列表
    "alarmconfig/alerthistorydetails": "/zl.fp.alarmconfig.alerthistory.details.v5/1.0.0/action",// 告警消息历史详情


    // 发送短信管理
    "smsmanager/list": "/zl.fp.smsAnalysis.queryPageList.v5/1.0.0/action",// 短信列表查询
    "smsmanager/details": "/zl.fp.smsAnalysis.details.v5/1.0.0/action",//   短信详情
    "smsmanager/querySendNumbersAnalysis": "/zl.fp.smsmanager.querySendNumbersAnalysis.v5/1.0.0/action",// 总发送统计
    "smsmanager/querySendNumbersAnalysisFailNumber": "/zl.fp.smsmanager.querySendNumbersAnalysisFailNumber.v5/1.0.0/action",//  发送失败统计
    "smsmanager/querySendNumbersAnalysisByDate": "/zl.fp.smsmanager.querySendNumbersAnalysisByDate.v5/1.0.0/action",//  柱状图
    "smsmanager/querySendFailedNumbersAnalysis": "/zl.fp.smsmanager.querySendFailedNumbersAnalysis.v5/1.0.0/action",//  折线图
    "smsmanager/querySmsSignnameList": "/zl.fp.smsmanager.querySmsSignnameList.v5/1.0.0/action",//  查询询签名下拉列表
    "smsmanager/updateSmsStatus": "/zl.fp.smsmanager.updateSmsStatus.v5/1.0.0/action",// 短信状态更新
    "smsmanager/resendmsg": "/zl.fp.smsmanager.resendmsg.v5/1.0.0/action",// 短信重发

    // 短信动态签名管理
    "smsmanager/querySignPageList": "/zl.fp.smsmanager.querySignPageList.v5/1.0.0/action",// 短信签名列表查询
    "smsmanager/detailSign": "/zl.fp.smsmanager.querySignDetails.v5/1.0.0/action",// 短信签名详情
    "smsmanager/addSign": "/zl.fp.smsmanager.addSign.v5/1.0.0/action",// 短信签名新增
    "smsmanager/editSign": "/zl.fp.smsmanager.editSign.v5/1.0.0/action",// 短信签名新增
    "smsmanager/deleteSign": "/zl.fp.smsmanager.deleteSign.v5/1.0.0/action",// 短信签名新增

    "smsmanager/querySignApplyPageList": "/zl.fp.smsmanager.smsSignApplyManager.queryPageList.v5/1.0.0/action",// 短信签名申请列表查询
    "smsmanager/detailSignApply": "/zl.fp.smsmanager.smsSignApplyManager.queryDetails.v5/1.0.0/action",// 短信签名申请详情
    "smsmanager/querySignApplyStatus": "/zl.fp.mt.smssign.querySmsSignApplyStatus.v5/1.0.0/action",// 短信签名申请详情

    // 短信模版管理
    "smsmanager/queryTemplatePageList": "/zl.fp.smsmanager.queryTemplatePageList.v5/1.0.0/action",// 短信模版列表查询
    "smsmanager/detailTemplate": "/zl.fp.smsmanager.queryTemplateDetails.v5/1.0.0/action",// 短信模版详情
    "smsmanager/addTemplate": "/zl.fp.smsmanager.addTemplate.v5/1.0.0/action",// 短信模版新增
    "smsmanager/editTemplate": "/zl.fp.smsmanager.editTemplate.v5/1.0.0/action",// 短信模版新增
    "smsmanager/deleteTemplate": "/zl.fp.smsmanager.deleteTemplate.v5/1.0.0/action",// 短信模版新增

    "smsmanager/queryTemplateApplyPageList": "/zl.fp.smsmanager.smsTemplateApplyManager.queryPageList.v5/1.0.0/action",// 短信模版申请列表查询
    "smsmanager/detailTemplateApply": "/zl.fp.smsmanager.smsTemplateApplyManager.queryDetails.v5/1.0.0/action",// 短信模版申请详情
    "smsmanager/queryTemplatteApplyStatus": "/zl.fp.pm.zlscms.smstemplate.querySmsTemplateApplyStatus.v5/1.0.0/action",// 短信签名申请详情

    // 微信模版管理
    "wxtemplatemanager/queryWXtemplateList": "/zl.fp.wxtemplatemanager.queryTemplatePageList.v5/1.0.0/action",// 微信模版列表查询
    "wxtemplatemanager/detailTemplate": "/zl.fp.wxtemplatemanager.queryTemplateDetails.v5/1.0.0/action",// 微信模版详情
    "wxtemplatemanager/addTemplate": "/zl.fp.wxtemplatemanager.addTemplate.v5/1.0.0/action",// 微信模版新增
    "wxtemplatemanager/editTemplate": "/zl.fp.wxtemplatemanager.editTemplate.v5/1.0.0/action",// 微信模版修改
    "wxtemplatemanager/deleteTemplate": "/zl.fp.wxtemplatemanager.deleteTemplate.v5/1.0.0/action",// 微信模版删除

    //短信签名管理
    // 签名分页查询
    "wxtemplatemanager/querySmsSignApplyPageList": "/zl.fp.pm.smssign.querySmsSignApplyPageList.v5/1.0.0/action",
    // 签名详情
    "wxtemplatemanager/querySmsSignDetails": "/zl.fp.pm.smssign.querySmsSignDetails.v5/1.0.0/action",
    // 签名删除
    "wxtemplatemanager/deleteSmsSignApply": "/zl.fp.pm.smssign.deleteSmsSignApply.v5/1.0.0/action",
    // 签名新增
    "wxtemplatemanager/addSmsSignApply": "/zl.fp.mt.smssign.addSmsSignApply.v5/1.0.0/action",
    // 签名查询结果
    "wxtemplatemanager/querySmsSignApplyStatus": "/zl.fp.pm.smssign.querySmsSignApplyStatus/1.0.0/action",
    // 签名修改
    "wxtemplatemanager/editSmsSignApply": "/zl.fp.mt.smssign.editSmsSignApply.v5/1.0.0/action",

    //短信模板管理
    "wxtemplatemanager/querySmsTemplateApplyPageList": "/zl.fp.pm.zlscms.smstemplate.querySmsTemplateApplyPageList.v5/1.0.0/action",
    "wxtemplatemanager/querySmsTemplateDetails": "/zl.fp.pm.zlscms.smstemplate.querySmsTemplateDetails.v5/1.0.0/action",
    "wxtemplatemanager/editSmsTemoplateApply": "/zl.fp.pm.zlscms.smstemplate.editSmsTemoplateApply.v5/1.0.0/action",
    "wxtemplatemanager/deleteSmsTemoplateApply": "/zl.fp.pm.zlscms.smstemplate.deleteSmsTemoplateApply.v5/1.0.0/action",
    "wxtemplatemanager/addSmsTemoplateApply": "/zl.fp.pm.zlscms.smstemplate.addSmsTemoplateApply.v5/1.0.0/action",
    "wxtemplatemanager/querySmsTemplateApplyStatus": "/zl.fp.pm.zlscms.smstemplate.querySmsTemplateApplyStatus.v5/1.0.0/action",


    //文件系统-导入导出配置

    //通用文件管理
    "filemanager/querycommonimportconfig": "zl.fp.comm.importconfig.queryconfig.v5/1.0.0/action",//市场监管平台导入配置列表
    "filemanager/updatecommonimportconfig": "zl.fp.comm.importconfig.updateconfig.v5/1.0.0/action",//市场监管平台导入配置更新
    "filemanager/addcommonimportconfig": "zl.fp.comm.importconfig.addconfig.v5/1.0.0/action",//市场监管平台导入配置新增
    "filemanager/deletecommonimportconfig": "zl.fp.comm.importconfig.deleteconfig.v5/1.0.0/action",//市场监管平台导入配置删除
    "filemanager/detailcommonimportconfig": "zl.fp.comm.importconfig.detailconfig.v5/1.0.0/action",//市场监管平台导入配置删除

    "filemanager/querycommonexportconfig": "zl.fp.comm.exportconfig.queryconfig.v5/1.0.0/action",//市场监管平台导出配置列表
    "filemanager/updatecommonexportconfig": "zl.fp.comm.exportconfig.updateconfig.v5/1.0.0/action",//市场监管平台导出配置更新
    "filemanager/addcommonexportconfig": "zl.fp.comm.exportconfig.addconfig.v5/1.0.0/action",//市场监管平台导出配置新增
    "filemanager/deletecommonexportconfig": "zl.fp.comm.exportconfig.deleteconfig.v5/1.0.0/action",//市场监管平台导出配置删除
    "filemanager/detailcommonexportconfig": "zl.fp.comm.exportconfig.detailconfig.v5/1.0.0/action",//市场监管平台导出配置删除

    'filemanager/osslist': '/zl.fp.oss.manage.queryossfilepage.v5/1.0.0/action', //OSS文件列表
    'filemanager/ossdel': '/zl.fp.oss.manage.deleteossfile.v5/1.0.0/action', //删除文件
    'filemanager/osskey': '/zl.fp.oss.manage.common.postobjectpolicy.v5/1.0.0/action', //oss秘钥
    'filemanager/ossplatformlist': '/zl.fp.fpv5.platform.queryByModule.v5/1.0.0/action', // 获取OSS平台

    //磐石导出记录
    // "filemanager/queryfpexportrecord": "zl.fp.fp.exportrecord.querypage.v5/1.0.0/action",//磐石平台导出配置列表
    "filemanager/queryexportrecord": "zl.fp.fmsv5.commonExportRecord.queryExportRecordPage.v5/1.0.0/action",
    "filemanager/queryimportrecord": "zl.fp.fmsv5.commonImport.queryImportRecordPage.v5/1.0.0/action",
    "filemanager/queryPlatformList": "zl.fp.fmsv5.platformConfig.queryList.v5/1.0.0/action",
    "filemanager/queryPlatformPage": "zl.fp.fmsv5.platformConfig.queryPage.v5/1.0.0/action",
    "filemanager/detailPlatformPage": "zl.fp.fmsv5.platformConfig.query.v5/1.0.0/action",
    "filemanager/editPlatformPage": "zl.fp.fmsv5.platformConfig.update.v5/1.0.0/action",
    "filemanager/delPlatformPage": "zl.fp.fmsv5.platformConfig.del.v5/1.0.0/action",
    "filemanager/addPlatformPage": "zl.fp.fmsv5.platformConfig.add.v5/1.0.0/action",

    "filemanager/exportQueryDiff": "zl.fp.fmsv5.commonExportConfig.queryDiff.v5/1.0.0/action",
    "filemanager/importQueryDiff": "zl.fp.fmsv5.commonImportConfig.queryDiff.v5/1.0.0/action",
    "filemanager/exportConfigTransfer": "zl.fp.fmsv5.commonExportConfig.configTransfer.v5/1.0.0/action",
    "filemanager/importConfigTransfer": "zl.fp.fmsv5.commonImportConfig.configTransfer.v5/1.0.0/action",





    //定时任务管理
    "jobcenter/queryJobStatus": "dashboardInfo",//首页统计
    "jobcenter/getchartInfo": "getchartInfo",//首页图表

    "jobcenter/queryjobcenter": "jobinfo/jobList",//任务列表
    "jobcenter/queryEnum": "jobinfo/getEnum",//枚举列表
    "jobcenter/trigger": "jobinfo/trigger",//执行一次
    "jobcenter/logKill": "joblog/logKill",//终止
    "jobcenter/loglist": "joblog/pageList",//调度日志列表
    "jobcenter/getJobsByGroup": "/joblog/getJobsByGroup",//获取任务下拉

    "jobcenter/loadById": "jobgroup/loadById",//注册节点
    "jobcenter/nextTriggerTime": "jobinfo/nextTriggerTime",//下次执行时间
    "jobcenter/start": "jobinfo/start",//启动
    "jobcenter/stop": "jobinfo/stop",//停止
    "jobcenter/remove": "jobinfo/remove",//删除
    "jobcenter/update": "jobinfo/update",//编辑
    "jobcenter/add": "jobinfo/add",//编辑

    "jobcenter/jobgrouplist": "jobgroup/pageList",//执行器管理
    "jobcenter/removeJobGroup": "jobgroup/remove",
    "jobcenter/addJobGroup": "jobgroup/save",
    "jobcenter/editJobGroup": "jobgroup/update",

    "jobcenter/logDetailCat": "joblog/logDetailCat",



    "jobcenter/updatejobcenter": "zl.fp.fp.importconfig.updateconfig.v5/1.0.0/action",//磐石平台导入配置更新
    "jobcenter/addjobcenter": "zl.fp.fp.importconfig.addconfig.v5/1.0.0/action",//磐石平台导入配置新增
    "jobcenter/deletejobcenter": "zl.fp.fp.importconfig.deleteconfig.v5/1.0.0/action",//磐石平台导入配置删除
    "jobcenter/detailjobcenter": "zl.fp.fp.importconfig.detailconfig.v5/1.0.0/action",//磐石平台导入配置删除

    'app/getAppItem': '/zl.fp.appservicekeybind.queryappitem.v5/1.0.0/action', //获取app详情
    'app/queryAppServicekeyBind': '/zl.fp.appservicekeybind.queryappservicekeybind.v5/1.0.0/action', //获取app详情
    'app/deleteAppServicekeyBind': '/zl.fp.appservicekeybind.deleteappservicekeybind.v5/1.0.0/action', //获取app详情
    'app/addAppServicekeyBind': '/zl.fp.appservicekeybind.addappservicekeybind.v5/1.0.0/action', //获取app详情
    'app/updateAppServicekeyBind': '/zl.fp.appservicekeybind.updateappservicekeybind.v5/1.0.0/action', //获取app详情
    'app/getAllAppServicekeyBind': '/zl.fp.appservicekeybind.getallappservicekeybind.v5/1.0.0/action', //获取app详情

    //app的域名绑定关系
    'app/getAppDomainBind': '/zl.fp.appdomainbind.getallappdomainbind.v5/1.0.0/action', //获取app详情
    'app/addAppDomainBind': '/zl.fp.appdomainbind.addappdomainbind.v5/1.0.0/action', //获取app详情
    'app/deleteAppDomainBind': '/zl.fp.appdomainbind.deleteappdomainbind.v5/1.0.0/action', //获取app详情

    //ums
    'ums/searchPlatFromConfig': '/zl.fp.unite.menu.searchPlatFromConfig.v5/1.0.0/action', //获取app详情
    'ums/insertPlatFromConfig': '/zl.fp.unite.menu.insertPlatFromConfig.v5/1.0.0/action', //获取app详情
    'ums/editPlatFromConfig': '/zl.fp.unite.menu.updatePlatFromConfig.v5/1.0.0/action', //获取app详情
    "ums/searchMenuConfigTree": "/zl.fp.unite.menu.searchMenuConfigTree.v5/1.0.0/action",//获取所有的菜单
    "ums/insertMenuConfig": "/zl.fp.unite.menu.insertMenuConfig.v5/1.0.0/action",//新增菜单
    "ums/updateMenuConfig": "/zl.fp.unite.menu.updateMenuConfig.v5/1.0.0/action",//修改菜单
    "ums/deleteMenuConfig": "/zl.fp.unite.menu.deleteMenuConfig.v5/1.0.0/action",//删除菜单
    "ums/searchRoleConfig": "/zl.fp.unite.menu.searchRoleConfig.v5/1.0.0/action",//查询角色
    "ums/searchRoleConfigPage": "/zl.fp.unite.menu.searchRoleConfigPage.v5/1.0.0/action",//分页查询角色
    "ums/updateRoleConfig": "/zl.fp.unite.menu.updateRoleConfig.v5/1.0.0/action",//更新角色
    "ums/deleteRoleConfig": "/zl.fp.unite.menu.deleteRoleConfig.v5/1.0.0/action",//删除角色
    "ums/insertRoleConfig": "/zl.fp.unite.menu.insertRoleConfig.v5/1.0.0/action",//插入角色
    "ums/menuExport": "/zl.fp.unite.menu.commonExport.v5/1.0.0/action",//导出菜单
    "ums/menuImport": "/zl.fp.unite.menu.commonImport.v5/1.0.0/action",//导入菜单

    "ums/searchUserRoles": "/zl.fp.unite.user.searchUserRoles.v5/1.0.0/action",//查询用户角色
    "ums/searchUserRolesByUser": "/zl.fp.unite.user.searchUserRolesByUser.v5/1.0.0/action",//查询用户角色以用户维度
    "ums/insertUserRole": "/zl.fp.unite.user.insertUserRole.v5/1.0.0/action",//新增用户角色
    "ums/updateUserRole": "/zl.fp.unite.user.updateUserRole.v5/1.0.0/action",//更新用户角色
    "ums/deleteUserRole": "/zl.fp.unite.user.deleteUserRole.v5/1.0.0/action",//删除用户角色
    "ums/searchUserList": "/zl.fp.unite.user.searchUserList.v5/1.0.0/action",//查询用户
    "ums/updateUserAuth": "/zl.fp.unite.user.updateUserAuthNoOld.v5/1.0.0/action",//更新用户授权信息
    "ums/updateUser": "/zl.fp.unite.user.updateUser.v5/1.0.0/action",//更新用户信息
    "ums/searchUserAndAuth": "/zl.fp.unite.user.searchUserAndAuth.v5/1.0.0/action",//查询用户与授权信息
    "ums/registerUser": "/zl.fp.unite.user.registerUser.v5/1.0.0/action",//平台注册用户
    "ums/searchUMSUserDetail": "/zl.fp.unite.user.searchUMSUserDetail.v5/1.0.0/action",//查询磐石用户相关权限
    "ums/updateUMSUserDetail": "/zl.fp.unite.user.updateUMSUserDetail.v5/1.0.0/action",//修改磐石用户相关权限
    'ums/updateUserAuth4Fp': 'zl.fp.unite.user.updateUserAuth4Fp.v5/1.0.0/action',

    'ums/queryRoleSys': 'zl.fp.fpv5.roleSystem.querypage.v5/1.0.0/action',
    'ums/delRoleSys': 'zl.fp.fpv5.roleSystem.del.v5/1.0.0/action',
    'ums/addRoleSys': 'zl.fp.fpv5.roleSystem.insertOrUpdate.v5/1.0.0/action',


    // appdomainbind.getallappdomainbind
    //appdomainbind.addappdomainbind
    //appdomainbind.deleteappdomainbind


    'notice/querynoticelist': '/zl.fp.noticemanager.querynoticelist.v5/1.0.0/action', //获取app详情
    'notice/editnotice': '/zl.fp.noticemanager.editnotice.v5/1.0.0/action', //获取app详情
    'notice/addnotice': '/zl.fp.noticemanager.addnotice.v5/1.0.0/action', //获取app详情
    'notice/deletenotice': '/zl.fp.noticemanager.deletenotice.v5/1.0.0/action', //获取app详情
    'notice/detailnotice': '/zl.fp.noticemanager.detailnotice.v5/1.0.0/action', //获取app详情

    //阿里日志服务
    'logservice/querylogproject': 'zl.fp.alilogmanager.querylogproject.v5/1.0.0/action', //
    'logservice/addlogproject': '/zl.fp.alilogmanager.addlogproject.v5/1.0.0/action', //
    'logservice/querylogstore': '/zl.fp.alilogmanager.querylogstore.v5/1.0.0/action', //
    'logservice/addlogstore': '/zl.fp.alilogmanager.addlogstore.v5/1.0.0/action', //
    'logservice/querylogindex': '/zl.fp.alilogmanager.querylogindex.v5/1.0.0/action', //
    'logservice/addlogindex': '/zl.fp.alilogmanager.addlogindex.v5/1.0.0/action', //
    'logservice/deletelogindex': '/zl.fp.alilogmanager.deletelogindex.v5/1.0.0/action', //
    'logservice/querylog': '/zl.fp.alilogmanager.querylog.v5/1.0.0/action', //
    'logservice/querylogsql': '/zl.fp.alilogmanager.querylogsql.v5/1.0.0/action', //
    'logservice/addlogsql': '/zl.fp.alilogmanager.addlogsql.v5/1.0.0/action', //
    'logservice/deletelogsql': '/zl.fp.alilogmanager.deletelogsql.v5/1.0.0/action', //

    'logservice/updatelogindex': '/zl.fp.alilogmanager.updatelogindex.v5/1.0.0/action', //
    'logservice/queryoverview': '/zl.fp.applogdashboard.queryoverview.v5/1.0.0/action', //
    'logservice/queryfolow': '/zl.fp.applogdashboard.queryfolow.v5/1.0.0/action', //
    'logservice/updatefolow': '/zl.fp.applogdashboard.updatefolow.v5/1.0.0/action', //
    'logservice/queryfolowsys': '/zl.fp.applogdashboard.queryfolowsys.v5/1.0.0/action', //

    'logservice/addfolow': '/zl.fp.applogdashboard.addfolow.v5/1.0.0/action', //
    'logservice/deletefolow': '/zl.fp.applogdashboard.deletefolow.v5/1.0.0/action', //
    'logservice/queryauthedappcodes': '/zl.fp.applogdashboard.queryauthedappcodes.v5/1.0.0/action', //
    'logservice/queryfolowsyserror': '/zl.fp.applogdashboard.queryfolowsyserror.v5/1.0.0/action', //


    'mqinfo/searchMqInfo': '/zl.fp.tool.mqinfo.searchMqInfo.v5/1.0.0/action', //
    'mqinfo/queryGroupList': '/zl.fp.tool.mqinfo.queryGroupList.v5/1.0.0/action', //
    'mqinfo/searchMqInfoAndResendMessage': '/zl.fp.tool.mqinfo.searchMqInfoAndResendMessage.v5/1.0.0/action', //
    'mqinfo/searchMqInfoCount': '/zl.fp.tool.mqinfo.searchMqInfoCount.v5/1.0.0/action', //
    'mqinfo/resendMessage': '/zl.fp.tool.mqinfo.resendMessage.v5/1.0.0/action', //
    'mqinfo/selectResendLogs': '/zl.fp.tool.mqinfo.selectResendLogs.v5/1.0.0/action', //
    'mqinfo/queryResendProgress': '/zl.fp.tool.mqinfo.queryResendProgress.v5/1.0.0/action', //
    'mqinfo/searchTopics': '/zl.fp.tool.mqinfo.searchTopics.v5/1.0.0/action', //
    'mqinfo/queryDomainMap': '/zl.fp.tool.mqinfo.queryDomainMap.v5/1.0.0/action', //
    'mqinfo/selectResendLogsDetailOne': '/zl.fp.tool.mqinfo.selectResendLogsDetailOne.v5/1.0.0/action', //

    'logservice/queryhistorysys': '/zl.fp.alilogmanager.queryhistoryselecter.v5/1.0.0/action', //
    'logservice/gethistorychart': '/zl.fp.alilogmanager.gethistorychart.v5/1.0.0/action', //
    'logservice/gethistorypie': '/zl.fp.alilogmanager.gethistorypie.v5/1.0.0/action', //
    //0427
    'logservice/gethistoryurls': '/zl.fp.alilogmanager.gethistoryurls.v5/1.0.0/action', //
    'logservice/getservicehistoryday': '/zl.fp.alilogmanager.getservicehistoryday.v5/1.0.0/action', //
    'logservice/getservicehistoryhour': '/zl.fp.alilogmanager.getservicehistoryhour.v5/1.0.0/action', //


    //消息中心
    'mcmsmanager/querychannelone': '/zl.fp.mcms.selectMcmsChannelsOne.v5/1.0.0/action',
    'mcmsmanager/querychannels': '/zl.fp.mcms.selectMcmsChannels.v5/1.0.0/action',
    'mcmsmanager/querychannelpage': '/zl.fp.mcms.selectMcmsChannelsPage.v5/1.0.0/action',
    'mcmsmanager/addchannel': '/zl.fp.mcms.insertMcmsChannel.v5/1.0.0/action',
    'mcmsmanager/updatechannel': '/zl.fp.mcms.updateMcmsChannel.v5/1.0.0/action',
    'mcmsmanager/deletechannel': '/zl.fp.mcms.deleteMcmsChannels.v5/1.0.0/action',

    'mcmsmanager/selectRelatedPassways': 'zl.fp.mcms.doSelectRelatedPassways.v5/1.0.0/action',
    'mcmsmanager/saveRelatedPassways': 'zl.fp.mcms.doSaveRelatedPassways.v5/1.0.0/action',

    //0927
    'wechartsdk/queryconfig': '/zl.fp.wxcs.subscribe.getwxsignature.v5/1.0.0/action', //

    'mcmsmanager/querypasswayone': '/zl.fp.mcms.selectMcmsPasswaysOne.v5/1.0.0/action',
    'mcmsmanager/querypassways': '/zl.fp.mcms.selectMcmsPasswaysChannels.v5/1.0.0/action',
    'mcmsmanager/querypasswaypage': '/zl.fp.mcms.selectMcmsPasswaysPage.v5/1.0.0/action',
    'mcmsmanager/addpassway': '/zl.fp.mcms.insertMcmsPassway.v5/1.0.0/action',
    'mcmsmanager/updatepassway': '/zl.fp.mcms.updateMcmsPassway.v5/1.0.0/action',
    'mcmsmanager/deletepassway': '/zl.fp.mcms.deleteMcmsPassway.v5/1.0.0/action',


    'mcmsmanager/selectauthchannel': 'zl.fp.mcms.doSelectMcmsChannelsWithIsHavePassway.v5/1.0.0/action',
    'mcmsmanager/updateauthchannel': 'zl.fp.mcms.doSaveMcmsPasswayChannel.v5/1.0.0/action',

    'mcmsmanager/querytempleteone': '/zl.fp.mcms.selectMcmsTemplatePcsOne.v5/1.0.0/action',
    'mcmsmanager/querytempletes': '/zl.fp.mcms.selectMcmsTemplatePcs.v5/1.0.0/action',

    'mcmsmanager/deletetempletes': '/zl.fp.mcms.deleteMcmsTemplatePcs.v5/1.0.0/action',
    'mcmsmanager/querytempletepage': '/zl.fp.mcms.selectMcmsTemplatePcsPage.v5/1.0.0/action',
    'mcmsmanager/addtemplete': '/zl.fp.mcms.insertMcmsTemplatePc.v5/1.0.0/action',
    'mcmsmanager/updatetemplete': '/zl.fp.mcms.updateMcmsTemplatePc.v5/1.0.0/action',


    // 'mcmsmanager/querypasswaychannelone':'/zl.fp.mcms.selectMcmsPasswayChannelsOne.v5/1.0.0/action',
    // 'mcmsmanager/querypasswaychannels':'/zl.fp.mcms.selectMcmsPasswayChannels.v5/1.0.0/action',
    // 'mcmsmanager/querypasswaychannelpage':'/zl.fp.mcms.selectMcmsPasswayChannelsPage.v5/1.0.0/action',
    // 'mcmsmanager/addpasswaychannel':'/zl.fp.mcms.insertMcmsPasswayChannel.v5/1.0.0/action',
    'mcmsmanager/updatepasswaychannel': '/zl.fp.mcms.updateMcmsPasswayChannel.v5/1.0.0/action',

    'mcmsmanager/querytargetgroupsone': '/zl.fp.mcms.targetgroup.details.v5/1.0.0/action',
    'mcmsmanager/querytargetgroupspage': '/zl.fp.mcms.targetgroup.queryPageList.v5/1.0.0/action',
    'mcmsmanager/addtargetgroups': '/zl.fp.mcms.targetgroup.add.v5/1.0.0/action',
    'mcmsmanager/updatetargetgroups': '/zl.fp.mcms.targetgroup.edit.v5/1.0.0/action',
    'mcmsmanager/deletetargetgroup': '/zl.fp.mcms.targetgroup.del.v5/1.0.0/action',

    'mcmsmanager/batchinsert': '/zl.fp.mcms.targetgroup.batchinsert.v5/1.0.0/action',
    //平台列表
    'mcmsmanager/platforms': '/zl.fp.mcms.selectMcmsPlatformtypes.v5/1.0.0/action',

    //消息发送
    'mcmsmanager/configmessage': '/zl.fp.mcms.insertMcmsMessage.v5/1.0.0/action',
    'mcmsmanager/getpasswaybychannel': 'zl.fp.mcms.doSelectMcmsPasswaysByChannel.v5/1.0.0/action',
    'mcmsmanager/savemessage': 'zl.fp.mcms.targetmessage.save.v5/1.0.0/action',
    'mcmsmanager/savemessageapi': 'zl.fp.mcms.channel.sendmessage.v5/1.0.0/action',

    'mcmsmanager/querymessagepage': 'zl.fp.mcms.targetmessage.queryPageList.v5/1.0.0/action',

    //通道类型
    'mcmsmanager/querypasswaytypes': 'zl.fp.mcms.selectMcmsPasswaytypes.v5/1.0.0/action',

    //业务类型
    'mcmsmanager/selectMcmsMessageServices': 'zl.fp.mcms.selectMcmsMessageServices.v5/1.0.0/action',
    'mcmsmanager/selectMcmsMessageServicesOne': 'zl.fp.mcms.selectMcmsMessageServicesOne.v5/1.0.0/action',
    'mcmsmanager/selectMcmsMessageServicesPage': 'zl.fp.mcms.selectMcmsMessageServicesPage.v5/1.0.0/action',
    'mcmsmanager/deleteMcmsMessageServices': 'zl.fp.mcms.deleteMcmsMessageServices.v5/1.0.0/action',
    'mcmsmanager/handleUpdateFlagSevices': 'zl.fp.mcms.handleUpdateFlagSevices.v5/1.0.0/action',
    'mcmsmanager/insertMcmsMessageService': 'zl.fp.mcms.insertMcmsMessageService.v5/1.0.0/action',
    'mcmsmanager/updateMcmsMessageService': 'zl.fp.mcms.updateMcmsMessageService.v5/1.0.0/action',

    //业务分类
    'mcmsmanager/mcmsmessagetypeQuery': 'zl.fp.wsms.mcmsmessagetype.query/1.0.0/action',
    'mcmsmanager/mcmsmessagetypeAdd': 'zl.fp.wsms.mcmsmessagetype.add/1.0.0/action',
    'mcmsmanager/mcmsmessagetypeDel': 'zl.fp.wsms.mcmsmessagetype.del/1.0.0/action',
    'mcmsmanager/mcmsmessagetypeEdit': 'zl.fp.wsms.mcmsmessagetype.edit/1.0.0/action',

    //通道类型
    'mcmsmanager/selectMcmsPasswaytypes': 'zl.fp.mcms.selectMcmsPasswaytypes.v5/1.0.0/action',
    'mcmsmanager/selectMcmsPasswaytypesOne': 'zl.fp.mcms.selectMcmsPasswaytypesOne.v5/1.0.0/action',
    'mcmsmanager/selectMcmsPasswaytypesPage': 'zl.fp.mcms.selectMcmsPasswaytypesPage.v5/1.0.0/action',
    'mcmsmanager/deleteMcmsPasswaytypes': 'zl.fp.mcms.deleteMcmsPasswaytypes.v5/1.0.0/action',
    'mcmsmanager/insertMcmsPasswaytype': 'zl.fp.mcms.insertMcmsPasswaytype.v5/1.0.0/action',
    'mcmsmanager/updateMcmsPasswaytype': 'zl.fp.mcms.updateMcmsPasswaytype.v5/1.0.0/action',

    //平台类型
    'mcmsmanager/selectMcmsPlatformtypes': 'zl.fp.mcms.selectMcmsPlatformtypes.v5/1.0.0/action',
    'mcmsmanager/selectMcmsPlatformtypesOne': 'zl.fp.mcms.selectMcmsPlatformtypesOne.v5/1.0.0/action',
    'mcmsmanager/selectMcmsPlatformtypesPage': 'zl.fp.mcms.selectMcmsPlatformtypesPage.v5/1.0.0/action',
    'mcmsmanager/deleteMcmsPlatformtypes': 'zl.fp.mcms.deleteMcmsPlatformtypes.v5/1.0.0/action',
    'mcmsmanager/insertMcmsPlatformtype': 'zl.fp.mcms.insertMcmsPlatformtype.v5/1.0.0/action',
    'mcmsmanager/updateMcmsPlatformtype': 'zl.fp.mcms.updateMcmsPlatformtype.v5/1.0.0/action',

    //消息记录表
    'mcmsmanager/selectMcmsMessageRecordsPage': 'zl.fp.mcms.selectMcmsMessageRecordsPage.v5/1.0.0/action',
    'mcmsmanager/resendMcmsMessageRecord': 'zl.fp.mcmsv5.targetMessage.reSend.v5/1.0.0/action',

    //socket管理
    'mcmsmanager/querydevicev3page': 'zl.fp.wsms.querydevicev3page/1.0.0/action',
    'mcmsmanager/querydevicepage': 'zl.fp.wsms.querydevicepage/1.0.0/action',
    'mcmsmanager/querymsghistoryv3page': 'zl.fp.wsms.querymsghistoryv3page/1.0.0/action',
    'mcmsmanager/querymsghistorypage': 'zl.fp.wsms.querymsghistorypage/1.0.0/action',
    'mcmsmanager/sendmsgv3thistory': 'zl.fp.wsms.push.sendmsgv3thistory/1.0.0/action',
    'mcmsmanager/sendmsgthistory': 'zl.fp.wsms.push.sendmsgthistory/1.0.0/action',
    'mcmsmanager/analysisResult': 'zl.fp.mcms.analysisResult.query.v5/1.0.0/action',
    'mcmsmanager/queryWebsocketoIpstatPageList': 'zl.fp.wsms.queryWebsocketoIpstatPageList/1.0.0/action',
    'mcmsmanager/queryWebsocketoIpstatDetailPageList': 'zl.fp.wsms.queryWebsocketoIpstatDetailPageList/1.0.0/action',

    'mcmsmanager/v3deleteDevice': 'zl.fp.wsms.device.v3delete/1.0.0/action',
    'mcmsmanager/deleteDevice': 'zl.fp.wsms.device.delete/1.0.0/action',
    'mcmsmanager/queryReadCt': 'zl.fp.mcms.analysisResult.queryReadCt.v5/1.0.0/action',
    'mcmsmanager/queryListByChannelCode': 'zl.fp.mcms.messageType.queryListByChannelCode.v5/1.0.0/action',
    'mcmsmanager/queryTouchCt': 'zl.fp.mcms.analysisResult.queryTouchCt.v5/1.0.0/action',
    'mcmsmanager/queryMessageSendByStatus': 'zl.fp.mcms.analysisResult.queryMessageSendByStatus.v5/1.0.0/action',
    'mcmsmanager/queryMessageSendByType': 'zl.fp.mcms.analysisResult.queryMessageSendByType.v5/1.0.0/action',

    'mcmsmanager/querySendMsgCt': 'zl.fp.smsAnalysis.querySendMsgCt.v5/1.0.0/action',


    //开放平台
    //文章crud
    'open/selectOnedoc': 'zl.fp.open.doc.selectOpenDocsOne.v5/1.0.0/action',
    'open/deletedoc': 'zl.fp.open.doc.deleteOpenDocs.v5/1.0.0/action',
    'open/adddoc': 'zl.fp.open.doc.insertOpenDoc.v5/1.0.0/action',
    'open/updatedoc': 'zl.fp.open.doc.updateOpenDoc.v5/1.0.0/action',
    'open/selectdoclist': 'zl.fp.open.doc.selectOpenDocs.v5/1.0.0/action',
    'open/syncselectdoclist': 'zl.fp.open.doc.selectOpenDocs.v5/1.0.0/action',
    //yapi文档读取
    'open/yapilist': 'zl.fp.open.yapi.menuList.v5/1.0.0/action',
    'open/yapidesc': 'zl.fp.open.yapi.yApiDesc.v5/1.0.0/action',

    'open/selectOpenUserinfosPage': 'zl.fp.open.user.selectOpenUserinfosPageFP.v5/1.0.0/action',
    'open/selectOpenUserinfosOne': 'zl.fp.open.user.selectOpenUserinfosOneFP.v5/1.0.0/action',
    'open/insertOpenUserinfo': 'zl.fp.open.user.insertOpenUserinfoFP.v5/1.0.0/action',
    'open/updateOpenUserinfo': 'zl.fp.open.user.updateOpenUserinfoFP.v5/1.0.0/action',


    'wxmenus/requestForWxMenus': 'zl.fp.wx.wxmenus.requestForWxMenus.v5/1.0.0/action',
    'wxmenus/requestForSaveWxMenus': 'zl.fp.wx.wxmenus.requestForSaveWxMenus.v5/1.0.0/action',

    'open/dispatchQueryPageList': 'zl.fp.open.dispatchConfig.queryPageList/1.0.0/action',
    'open/dispatchQuery': 'zl.fp.open.dispatchConfig.query/1.0.0/action',
    'open/dispatchUpdate': 'zl.fp.open.dispatchConfig.update/1.0.0/action',
    'open/dispatchAdd': 'zl.fp.open.dispatchConfig.add/1.0.0/action',
    'open/dispatchDel': 'zl.fp.open.dispatchConfig.del/1.0.0/action',

    'open/districtManage': 'zl.fp.openv5.districtManage.queryPage.v5/1.0.0/action',

    'open/updateopenstate': 'zl.fp.open.updateopen.state.v5/1.0.0/action',
    'open/queryauth': 'zl.fp.open.auth.queryauth.v5/1.0.0/action',
    'open/updateauth': 'zl.fp.open.auth.updateauth.v5/1.0.0/action',

    //滑动验证码人机验证
    'open/slidervertify': 'zl.fp.open.slider.vertify.v5/1.0.0/action',

    'open/callbackInfospage': 'zl.fp.open.selectopen.callbackInfospage/1.0.0/action',

    'open/callbackAppManagePage': 'zl.fp.open.callbackAppManage.queryPage.v5/1.0.0/action',
    'open/callbackAppManageAdd': 'zl.fp.open.callbackAppManage.add.v5/1.0.0/action',
    'open/callbackAppManageDel': 'zl.fp.open.callbackAppManage.del.v5/1.0.0/action',
    'open/callbackAppManageEdit': 'zl.fp.open.callbackAppManage.update.v5/1.0.0/action',
    'open/callbackAppManageDetail': 'zl.fp.open.callbackAppManage.query.v5/1.0.0/action',

    'open/callbackAppManageAddTopic': 'zl.fp.open.callbackAppManage.addTopic.v5/1.0.0/action',
    'open/callbackAppManageDelTopic': 'zl.fp.open.callbackAppManage.delTopic.v5/1.0.0/action',
    'open/callbackAppManageQueryTopics': 'zl.fp.open.callbackAppManage.queryTopics.v5/1.0.0/action',

    'open/shortLinkAdd': 'zl.fp.open.shortLink.addFpLink.v5/1.0.0/action',
    'open/shortLinkDel': 'zl.fp.open.shortLink.delFpLink.v5/1.0.0/action',
    'open/shortLinkPage': 'zl.fp.open.shortLink.queryFpLinkPage.v5/1.0.0/action',


    'open/shortLinkTypeAdd': 'zl.fp.open.shortLink.addBuscode.v5/1.0.0/action',
    'open/shortLinkTypeDel': 'zl.fp.open.shortLink.delBuscode.v5/1.0.0/action',
    'open/shortLinkTypeEdit': 'zl.fp.open.shortLink.updateBuscode.v5/1.0.0/action',
    'open/shortLinkTypeDetail': 'zl.fp.open.shortLink.queryBuscode.v5/1.0.0/action',
    'open/shortLinkTypePage': 'zl.fp.open.shortLink.queryBuscodesPage.v5/1.0.0/action',

    'open/queryShortLink': 'zl.fp.open.shortLink.queryUrl.v5/1.0.0/action',



    //银响力菜单授权
    'ums/rolelist': 'zl.fp.urms.fprole.list.v5/1.0.0/action',

    //报文处理-- V3
    /* 报文处理 */
    "messageProcessingModel/omsquery": "/zl.fp.oms.mqmessage.queryxmlmessagepage/1.0.0/action", // 【报文处理】订单系统-列表 chr
    "messageProcessingModel/omsoperate": "/zl.fp.oms.mqmessage.optxmlmessage/1.0.0/action", // 【报文处理】订单系统-处理 chr
    "messageProcessingModel/omsdel": "/zl.fp.oms.mqmessage.deletexmlmessage/1.0.0/action", // 【报文处理】订单系统-删除 chr

    //进销存系统
    "messageProcessingModel/stmsquery": "/zl.fp.stms.mqmessage.queryxmlmessagepage/1.0.0/action", // 【报文处理】进销存系统-列表 chr
    "messageProcessingModel/stmsoperate": "/zl.fp.stms.mqmessage.optxmlmessage/1.0.0/action", // 【报文处理】进销存系统-处理 chr
    "messageProcessingModel/stmsdel": "/zl.fp.stms.mqmessage.deletexmlmessage/1.0.0/action", // 【报文处理】进销存系统-删除 chr

    //商品系统
    "messageProcessingModel/dcmsquery": "/zl.fp.dcms.mqmessage.queryxmlmessagepage/1.0.0/action", // 【报文处理】商品系统-列表 chr
    "messageProcessingModel/dcmsoperate": "/zl.fp.dcms.mqmessage.optxmlmessage/1.0.0/action", // 【报文处理】商品系统-处理 chr
    "messageProcessingModel/dcmsdel": "/zl.fp.dcms.mqmessage.deletexmlmessage/1.0.0/action", // 【报文处理】商品系统-删除 chr

    // 促销系统  salems
    "messageProcessingModel/salemsquery": "/zl.fp.salems.mqmessage.queryxmlmessagepage/1.0.0/action", // 报文处理-促销系统-列表 zql
    "messageProcessingModel/salemsdel": "/zl.fp.salems.mqmessage.deletexmlmessage/1.0.0/action", // 报文处理-促销系统-删除 zql
    "messageProcessingModel/salemsoperate": "/zl.fp.salems.mqmessage.optxmlmessage/1.0.0/action", // 报文处理-促销系统-处理 zql
    // 微商城系统 wxms
    "messageProcessingModel/wxmsquery": "/zl.fp.wxms.mqmessage.queryxmlmessagepage/1.0.0/action", // 报文处理-微商城系统-列表 zql
    "messageProcessingModel/wxmsdel": "/zl.fp.wxms.mqmessage.deletexmlmessage/1.0.0/action", // 报文处理-微商城系统-删除 zql
    "messageProcessingModel/wxmsoperate": "/zl.fp.wxms.mqmessage.mqmessage.optxmlmessage/1.0.0/action", // 报文处理-微商城系统-处理 zql
    // 会员系统 mbms
    "messageProcessingModel/mbmsquery": "/zl.fp.mbms.mqmessage.queryxmlmessagepage/1.0.0/action", // 报文处理-会员系统-列表 zql
    "messageProcessingModel/mbmsdel": "/zl.fp.mbms.mqmessage.deletexmlmessage/1.0.0/action", // 报文处理-会员系统-删除 zql
    "messageProcessingModel/mbmsoperate": "/zl.fp.mbms.mqmessage.optxmlmessage/1.0.0/action", // 报文处理-会员系统-处理 zql
    // 广告系统 acts
    "messageProcessingModel/actsquery": "/zl.fp.acts.mqmessage.queryxmlmessagepage/1.0.0/action", // 报文处理-广告系统-列表 zql
    "messageProcessingModel/actsoperate": "/zl.fp.acts.mqmessage.optxmlmessage/1.0.0/action", // 报文处理-广告系统 -处理 zql
    "messageProcessingModel/actsdel": "/zl.fp.acts.mqmessage.deletexmlmessage/1.0.0/action", // 报文处理-广告系统 -删除 zql
    // 用户系统 urms
    "messageProcessingModel/urmsquery": "/zl.fp.urms.mqmessage.queryxmlmessagepage/1.0.0/action", // 报文处理-用户系统-列表 zql
    "messageProcessingModel/urmsoperate": "/zl.fp.urms.mqmessage.optxmlmessage/1.0.0/action", // 报文处理-用户系统 -处理 zql
    "messageProcessingModel/urmsdel": "/zl.fp.urms.mqmessage.deletexmlmessage/1.0.0/action", // 报文处理-用户系统 -删除 zql
    // 支付系统 pays
    "messageProcessingModel/paysquery": "/zl.fp.pays.mqmessage.queryxmlmessagepage/1.0.0/action", // 报文处理-支付系统-列表 zql
    "messageProcessingModel/paysoperate": "/zl.fp.pays.mqmessage.optxmlmessage/1.0.0/action", // 报文处理-支付系统 -处理 zql
    "messageProcessingModel/paysdel": "/zl.fp.pays.mqmessage.deletexmlmessage/1.0.0/action", // 报文处理-支付系统 -删除 zql

    // 支付系统 pays
    "messageProcessingModel/zlscmsquery": "/zl.fp.zlscms.mqmessage.queryxmlmessagepage/1.0.0/action", // 报文处理-支付系统-列表 zql
    "messageProcessingModel/zlscmsoperate": "/zl.fp.zlscms.mqmessage.optxmlmessage/1.0.0/action", // 报文处理-支付系统 -处理 zql
    "messageProcessingModel/zlscmsdel": "/zl.fp.zlscms.mqmessage.deletexmlmessage/1.0.0/action", // 报文处理-支付系统 -删除 zql

    //报文处理-- V5
    /* 报文处理 */
    "messageProcessingModel/omsqueryv5": "/zl.fp.oms.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 【报文处理】订单系统-列表 chr
    "messageProcessingModel/omsoperatev5": "/zl.fp.oms.mqmessage.optxmlmessage.v5/1.0.0/action", // 【报文处理】订单系统-处理 chr
    "messageProcessingModel/omsdelv5": "/zl.fp.oms.mqmessage.deletexmlmessage.v5/1.0.0/action", // 【报文处理】订单系统-删除 chr

    //进销存系统
    "messageProcessingModel/stmsqueryv5": "/zl.fp.stms.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 【报文处理】进销存系统-列表 chr
    "messageProcessingModel/stmsoperatev5": "/zl.fp.stms.mqmessage.optxmlmessage.v5/1.0.0/action", // 【报文处理】进销存系统-处理 chr
    "messageProcessingModel/stmsdelv5": "/zl.fp.stms.mqmessage.deletexmlmessage.v5/1.0.0/action", // 【报文处理】进销存系统-删除 chr

    //商品系统
    "messageProcessingModel/dcmsqueryv5": "/zl.fp.dcms.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 【报文处理】商品系统-列表 chr
    "messageProcessingModel/dcmsoperatev5": "/zl.fp.dcms.mqmessage.optxmlmessage.v5/1.0.0/action", // 【报文处理】商品系统-处理 chr
    "messageProcessingModel/dcmsdelv5": "/zl.fp.dcms.mqmessage.deletexmlmessage.v5/1.0.0/action", // 【报文处理】商品系统-删除 chr

    // 促销系统  salems
    "messageProcessingModel/salemsqueryv5": "/zl.fp.salems.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 报文处理-促销系统-列表 zql
    "messageProcessingModel/salemsdelv5": "/zl.fp.salems.mqmessage.deletexmlmessage.v5/1.0.0/action", // 报文处理-促销系统-删除 zql
    "messageProcessingModel/salemsoperatev5": "/zl.fp.salems.mqmessage.optxmlmessage.v5/1.0.0/action", // 报文处理-促销系统-处理 zql
    // 微商城系统 wxms
    "messageProcessingModel/wxmsqueryv5": "/zl.fp.wxms.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 报文处理-微商城系统-列表 zql
    "messageProcessingModel/wxmsdelv5": "/zl.fp.wxms.mqmessage.deletexmlmessage.v5/1.0.0/action", // 报文处理-微商城系统-删除 zql
    "messageProcessingModel/wxmsoperatev5": "/zl.fp.wxms.mqmessage.mqmessage.optxmlmessage.v5/1.0.0/action", // 报文处理-微商城系统-处理 zql
    // 会员系统 mbms
    "messageProcessingModel/mbmsqueryv5": "/zl.fp.mbms.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 报文处理-会员系统-列表 zql
    "messageProcessingModel/mbmsdelv5": "/zl.fp.mbms.mqmessage.deletexmlmessage.v5/1.0.0/action", // 报文处理-会员系统-删除 zql
    "messageProcessingModel/mbmsoperatev5": "/zl.fp.mbms.mqmessage.optxmlmessage.v5/1.0.0/action", // 报文处理-会员系统-处理 zql
    // 广告系统 acts
    "messageProcessingModel/actsqueryv5": "/zl.fp.acts.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 报文处理-广告系统-列表 zql
    "messageProcessingModel/actsoperatev5": "/zl.fp.acts.mqmessage.optxmlmessage.v5/1.0.0/action", // 报文处理-广告系统 -处理 zql
    "messageProcessingModel/actsdelv5": "/zl.fp.acts.mqmessage.deletexmlmessage.v5/1.0.0/action", // 报文处理-广告系统 -删除 zql
    // 用户系统 urms
    "messageProcessingModel/urmsqueryv5": "/zl.fp.urms.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 报文处理-用户系统-列表 zql
    "messageProcessingModel/urmsoperatev5": "/zl.fp.urms.mqmessage.optxmlmessage.v5/1.0.0/action", // 报文处理-用户系统 -处理 zql
    "messageProcessingModel/urmsdelv5": "/zl.fp.urms.mqmessage.deletexmlmessage.v5/1.0.0/action", // 报文处理-用户系统 -删除 zql
    // 支付系统 pays
    "messageProcessingModel/paysqueryv5": "/zl.fp.pays.mqmessage.queryxmlmessagepage.v5/1.0.0/action", // 报文处理-支付系统-列表 zql
    "messageProcessingModel/paysoperatev5": "/zl.fp.pays.mqmessage.optxmlmessage.v5/1.0.0/action", // 报文处理-支付系统 -处理 zql
    "messageProcessingModel/paysdelv5": "/zl.fp.pays.mqmessage.deletexmlmessage.v5/1.0.0/action", // 报文处理-支付系统 -删除 zql

    //分支管理
    // "branch/getallbranches": "/zl.fp.fpv5.jenkins.getallbranches.v5/1.0.0/action", // 分支管理-分支下拉
    "branch/getallbranches": "/svn/get_all_branches", // 分支管理-分支下拉

    "branch/getreleaserecords": "/zl.fp.fpv5.jenkins.getreleaserecords.v5/1.0.0/action", // 分支管理-分支下拉

    //云端配置中心
    "cloudconfig/addcatalog": "/zl.fp.umsv5.configmanager.addcatalog.v5/1.0.0/action", // 目录新增
    "cloudconfig/delcatalog": "/zl.fp.umsv5.configmanager.delcatalog.v5/1.0.0/action", // 目录删除
    "cloudconfig/updatecatalog": "/zl.fp.umsv5.configmanager.updatecatalog.v5/1.0.0/action", // 目录修改
    "cloudconfig/querycatalogs": "/zl.fp.umsv5.configmanager.querycatalogs.v5/1.0.0/action", // 查询目录

    "cloudconfig/addrule": "/zl.fp.umsv5.configmanager.addrule.v5/1.0.0/action", // 新增配置规则
    "cloudconfig/delrule": "/zl.fp.umsv5.configmanager.delrule.v5/1.0.0/action", // 删除配置规则
    "cloudconfig/updaterule": "/zl.fp.umsv5.configmanager.updaterule.v5/1.0.0/action", // 更新配置规则
    "cloudconfig/queryrulespage": "/zl.fp.umsv5.configmanager.queryrulespage.v5/1.0.0/action", // 分页查询配置规则

    "cloudconfig/addconfiginfo": "/zl.fp.umsv5.configmanager.addconfiginfo.v5/1.0.0/action", // 配置元数据新增
    "cloudconfig/delconfiginfo": "/zl.fp.umsv5.configmanager.delconfiginfo.v5/1.0.0/action", // 配置元数据删除
    "cloudconfig/updateconfiginfo": "/zl.fp.umsv5.configmanager.updateconfiginfo.v5/1.0.0/action", // 配置元数据更新
    "cloudconfig/queryconfiginfopage": "/zl.fp.umsv5.configmanager.queryconfiginfopage.v5/1.0.0/action", // 配置元数据分页查询
    "cloudconfig/queryconfiginfo": "/zl.fp.umsv5.configmanager.queryconfiginfo.v5/1.0.0/action", // 配置元数详情

    //配置明细
    "cloudconfig/queryconfigdetailpage": "/zl.fp.umsv5.configmanager.queryconfigdetailpage.v5/1.0.0/action", // 配置明细
    "cloudconfig/saveconfig": "/zl.fp.umsv5.configcloud.saveconfig.v5/1.0.0/action",//新增编辑
    "cloudconfig/queryconfig": "/zl.fp.umsv5.configcloud.queryconfig.v5/1.0.0/action",//查询详情
    "cloudconfig/delconfig": "/zl.fp.umsv5.configcloud.delconfig.v5/1.0.0/action",//配置删除
    "cloudconfig/configcover": "/zl.fp.umsv5.configcloud.configcover.v5/1.0.0/action",//覆盖配置

    //简单配置
    "cloudconfig/simpquerypage": "/zl.fp.umsv5.simpleconfig.querypage.v5/1.0.0/action",//分页查询
    "cloudconfig/simpadd": "/zl.fp.umsv5.simpleconfig.add.v5/1.0.0/action",//新增
    "cloudconfig/simpdel": "/zl.fp.umsv5.simpleconfig.del.v5/1.0.0/action",//删除
    "cloudconfig/simpedit": "/zl.fp.umsv5.simpleconfig.update.v5/1.0.0/action",//编辑
    "cloudconfig/simpdetail": "/zl.fp.umsv5.simpleconfig.query.v5/1.0.0/action",//详情
    "cloudconfig/simpquerybycatalog": "/zl.fp.umsv5.simpleconfig.querybycatalog.v5/1.0.0/action",//查询目录下配置

    "cloudconfig/queryplatform": "/zl.fp.umsv5.configmanager.queryplatform.v5/1.0.0/action", // 平台列表

    //redis管理
    "redis/key": "/zl.fp.fpv5.redis.key/1.0.0/action",//模糊查询所以的KEY接口
    "redis/getvalues": "/zl.fp.fpv5.redis.getvalues/1.0.0/action",//根据KEY查询对应的值接口
    "redis/delkey": "/zl.fp.fpv5.redis.delkey/1.0.0/action",//根据KEY删除对应的值接口
    "redis/delallkey": "/zl.fp.fpv5.redis.delallkey/1.0.0/action",//清理所有缓存接口

    "redis/routesend": "/zl.fp.fpv5.nginxroute.routesend/1.0.0/action",//根据KEY查询对应的值接口
    "redis/routesendPage": "/zl.fp.fpv5.nginxroute.routesendPage/1.0.0/action",

    "project/query": "/zl.fp.project.query.v5/1.0.0/action",//项目管理
    "project/add": "/zl.fp.project.add.v5/1.0.0/action",//项目管理
    "project/edit": "/zl.fp.project.edit.v5/1.0.0/action",//项目管理
    "project/delete": "/zl.fp.project.delete.v5/1.0.0/action",//项目管理

    "kamanager/queryaccountpage": "/zl.fp.fpv5.keyAccount.queryPage.v5/1.0.0/action",//KA环境信息分页查询
    "kamanager/queryaccount": "/zl.fp.fpv5.keyAccount.query.v5/1.0.0/action",//KA客户环境信息查询
    "kamanager/addaccount": "/zl.fp.fpv5.keyAccount.add.v5/1.0.0/action",//新增KA客户环境
    "kamanager/destroyaccount": "/zl.fp.fpv5.keyAccount.destroy.v5/1.0.0/action",//销毁KA环境信息
    "kamanager/updateaccount": "/zl.fp.fpv5.keyAccount.update.v5/1.0.0/action",//KA环境信息更新
    "kamanager/syncjenkins": "/zl.fp.fpv5.keyAccount.syncJenkins.v5/1.0.0/action",//KA环境同步Jenkins

    "kamanager/addrelateSys": "/zl.fp.fpv5.keyAccount.relateSys.v5/1.0.0/action",//查询当前所有关联系统
    "kamanager/queryRelatedSys": "/zl.fp.fpv5.keyAccount.queryRelatedSys.v5/1.0.0/action",//查询当前所有关联系统
    "kamanager/updaterelatesys": "/zl.fp.fpv5.keyAccount.updateRelation.v5/1.0.0/action",//更新关联系统
    "kamanager/detailrelatesys": "/zl.fp.fpv5.keyAccount.queryRelatedSysDetail.v5/1.0.0/action",//关联系统详情
    "kamanager/queryrelatesys": "/zl.fp.fpv5.keyAccount.queryRelatableSys.v5/1.0.0/action",//查询所有可关联系统
    "kamanager/updateRelation": "/zl.fp.fpv5.keyAccount.updateRelation.v5/1.0.0/action",//KA环境关联系统更新
    "kamanager/disableRelation": "/zl.fp.fpv5.keyAccount.disableRelation.v5/1.0.0/action",//解除关联系统

    "kamanager/queryTask": "/zl.fp.fpv5.keyAccount.queryTask.v5/1.0.0/action",//查询任务状态

    "kamanager/queryJenkins": "/zl.fp.fpv5.sysJenkinsData.query.v5/1.0.0/action",//
    "kamanager/addJenkins": "/zl.fp.fpv5.sysJenkinsData.add.v5/1.0.0/action",//
    "kamanager/pageJenkins": "/zl.fp.fpv5.sysJenkinsData.queryPage.v5/1.0.0/action",//
    "kamanager/delJenkins": "/zl.fp.fpv5.sysJenkinsData.del.v5/1.0.0/action",//
    "kamanager/updateJenkins": "/zl.fp.fpv5.sysJenkinsData.update.v5/1.0.0/action",//

    "kamanager/queryres": "/zl.fp.fpv5.kaAllocate.query.v5/1.0.0/action",//
    "kamanager/addres": "/zl.fp.fpv5.kaAllocate.add.v5/1.0.0/action",//
    "kamanager/updateres": "/zl.fp.fpv5.kaAllocate.update.v5/1.0.0/action",//

    "kamanager/addDomain": "/zl.fp.fpv5.KaDomain.add.v5/1.0.0/action",//域名新增
    "kamanager/queryDomain": "/zl.fp.fpv5.KaDomain.query.v5/1.0.0/action",//详情
    "kamanager/pageDomain": "/zl.fp.fpv5.KaDomain.queryPage.v5/1.0.0/action",//分页
    "kamanager/dispatchDomain": "/zl.fp.fpv5.KaDomain.dispatch.v5/1.0.0/action",//下发
    "kamanager/destroyDomain": "/zl.fp.fpv5.KaDomain.destroy.v5/1.0.0/action",//销毁

    "kamanager/listMiddleware": "/zl.fp.fpv5.KaMiddlewareManage.queryList.v5/1.0.0/action",//中间件列表
    "kamanager/addMiddleware": "/zl.fp.fpv5.KaMiddlewareManage.add.v5/1.0.0/action",//新增中间件
    "kamanager/delMiddleware": "/zl.fp.fpv5.KaMiddlewareManage.del.v5/1.0.0/action",//删除中间件
    "kamanager/queryMiddleware": "/zl.fp.fpv5.KaMiddlewareManage.query.v5/1.0.0/action",//查询中间件详情
    "kamanager/updateMiddleware": "/zl.fp.fpv5.KaMiddlewareManage.update.v5/1.0.0/action",//更新中间件

    "kamanager/queryDefaultConfig": "/zl.fp.fpv5.keyAccount.queryRelatedSysDetail.v5/1.0.0/action",//查询关联系统应用配置

    "kamanager/buildJob": "/zl.fp.fpv5.keyAccount.buildJob.v5/1.0.0/action",//构建系统
    "kamanager/queryJobStatus": "/zl.fp.fpv5.keyAccount.queryJobStatus.v5/1.0.0/action",//查询构建系统状态

    "kamanager/queryJobUrl": "/zl.fp.fpv5.keyAccount.queryJobUrl.v5/1.0.0/action",//系统构建
    "kamanager/syncJenkinsOne": "/zl.fp.fpv5.keyAccount.syncJenkinsOne.v5/1.0.0/action",//配置下发



    //处理器配置
    "servicekey/processorAddClass": "/zl.fp.zkms.processorConfig.addClass.v5/1.0.0/action",
    "servicekey/processorDelClass": "/zl.fp.zkms.processorConfig.delClass.v5/1.0.0/action",
    "servicekey/processorEditClass": "/zl.fp.zkms.processorConfig.editClass.v5/1.0.0/action",
    "servicekey/processorQueryClass": "/zl.fp.zkms.processorConfig.queryClass.v5/1.0.0/action",
    "servicekey/processorQueryClassListPage": "/zl.fp.zkms.processorConfig.queryClassListPage.v5/1.0.0/action",
    "servicekey/processorRefreshClass": "/zl.fp.zkms.processorConfig.refreshClass.v5/1.0.0/action",

    //处理器映射配置
    "servicekey/processorAdd": "/zl.fp.zkms.processorConfig.add.v5/1.0.0/action",
    "servicekey/processorDel": "/zl.fp.zkms.processorConfig.del.v5/1.0.0/action",
    "servicekey/processorEdit": "/zl.fp.zkms.processorConfig.edit.v5/1.0.0/action",
    "servicekey/processorQuery": "/zl.fp.zkms.processorConfig.query.v5/1.0.0/action",
    "servicekey/processorQueryListPage": "/zl.fp.zkms.processorConfig.queryListPage.v5/1.0.0/action",
    "servicekey/processorRefresh": "/zl.fp.zkms.processorConfig.refresh.v5/1.0.0/action",
    "servicekey/processorActive": "/zl.fp.zkms.processorConfig.disable.v5/1.0.0/action",

    // 系统管理-平台管理
    "platformlist/platformAdd": "/zl.fp.fpv5.platform.add.v5/1.0.0/action",
    "platformlist/platformDel": "/zl.fp.fpv5.platform.del.v5/1.0.0/action",
    "platformlist/platformEdit": "/zl.fp.fpv5.platform.edit.v5/1.0.0/action",
    "platformlist/platformDetail": "/zl.fp.fpv5.platform.detail.v5/1.0.0/action",
    "platformlist/queryPlatformPage": "/zl.fp.fpv5.platform.queryPage.v5/1.0.0/action",
    "platformlist/platformDispatch": "/zl.fp.fpv5.platform.dispatch.v5/1.0.0/action",









}
export default API
